import { render, staticRenderFns } from "./DuplicateUnitModal.vue?vue&type=template&id=bf8f484e&scoped=true&"
import script from "./DuplicateUnitModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateUnitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8f484e",
  null
  
)

export default component.exports